import TransportSwitcher from '../../reusable/Switchers/TransportSwitcher/TransportSwitcher'
// import SearchFilter from './SearchFilter'
import SelectFilter from './SelectFilter'

const RouteFilters = () => {
  return (
    <div className="route_filters">
      {/* <SearchFilter /> */}
      <TransportSwitcher />
      <SelectFilter />
    </div>
  )
}

export default RouteFilters
